/**
 * Release notes shown under "What's new" on the About page (OR-140).
 *
 * Entries are added ONLY after a release has shipped and ONLY with the owner's approval.
 * Ships EMPTY: while the list is empty the About page hides the "What's new" section.
 * One list for everyone (no roles); the page shows it newest first.
 *
 * Shape: { date: 'YYYY-MM-DD', title: string, points: string[] }
 */
export const RELEASE_NOTES = Object.freeze([]);
